import { gql } from '@apollo/client';

export const SET_JOB_STATUS_MUTATION = gql`
  mutation setJobStatus($jobId: Int!, $event: String!, $time: DateTime!) {
    setJobStatus(jobId: $jobId, event: $event, time: $time) {
      success
    }
  }
`;

export const REOPEN_CAP_MUTATION = gql`
  mutation reopenCap($jobId: Int!) {
    reopenCap(jobId: $jobId) {
      success
      error
    }
  }
`;

export const SAVE_JOB_RESULTS_MUTATION = gql`
  mutation saveJobResults(
    $jobId: Int!
    $checklistQuestionResults: [ChecklistQuestionResultInputObject!]!
    $datasheetQuestionResults: [DatasheetQuestionResultInputObject!]!
    $downloadedAt: DateTime
    $auditRealStartAt: DateTime
    $auditRealFinishAt: DateTime
    $capGeneratedAt: DateTime
    $uploadedAt: DateTime
    $repComments: String
    $facilityName: String
    $facilityDate: DateTime
    $assessorName: String
    $assessorDate: DateTime
  ) {
    saveJobResults(
      jobId: $jobId
      checklistQuestionResults: $checklistQuestionResults
      datasheetQuestionResults: $datasheetQuestionResults
      downloadedAt: $downloadedAt
      auditRealStartAt: $auditRealStartAt
      auditRealFinishAt: $auditRealFinishAt
      capGeneratedAt: $capGeneratedAt
      uploadedAt: $uploadedAt
      repComments: $repComments
      facilityName: $facilityName
      facilityDate: $facilityDate
      assessorName: $assessorName
      assessorDate: $assessorDate
    ) {
      success
    }
  }
`;

export const SAVE_QUESTION_RESULT_MUTATION = gql`
  mutation saveQuestionResult(
    $jobId: Int!
    $checklistQuestionResult: ChecklistQuestionResultInputObject
    $datasheetQuestionResult: SaveQuestionResultDatasheetQuestionResultInputObject
  ) {
    saveQuestionResult(
      jobId: $jobId
      checklistQuestionResult: $checklistQuestionResult
      datasheetQuestionResult: $datasheetQuestionResult
    ) {
      success
      error
    }
  }
`;

export const UPDATE_SAQ_SUBMISSION_REQUESTED = gql`
  mutation updateSaqSubmissionRequested(
    $jobId: Int!
  ) {
    updateSaqSubmissionRequested(
      jobId: $jobId
    ) {
      success
    }
  }
`;

export const SET_JOB_SEND_NOTIFICATION = gql`
  mutation(
    $jobId: Int!
    $sendNotification: Boolean!
  ) {
    setJobSendNotification(jobId: $jobId, sendNotification: $sendNotification) {
      success
    }
  }
`;

export const IMPORT_JOB_RESULTS = gql`
  mutation importJobResults(
    $jobToId: Int!
    $jobFromId: Int!
    $importChecklists: Boolean
    $importDatasheets: Boolean
  ) {
    importJobResults(
      jobToId: $jobToId
      jobFromId: $jobFromId
      importChecklists: $importChecklists
      importDatasheets: $importDatasheets
    ) {
      success
      checklistQuestionsWithErrors
    }
  }
`;

export const ADD_CHECKLIST_TO_JOB = gql`
  mutation addChecklistToJob(
    $jobId: Int!
    $checklistId: Int!
  ) {
    addChecklistToJob(
      jobId: $jobId
      checklistId: $checklistId
    ) {
      success
      error
    }
  }
`;

export const SET_SURVEY_DATA = gql`
  mutation setSurveyData(
    $jobId: Int!
    $datasheetVersionId: Int!
    $endDate: Date
    $prizeDrawUrl: String
  ) {
    setSurveyData(
      jobId: $jobId
      datasheetVersionId: $datasheetVersionId
      endDate: $endDate
      prizeDrawUrl: $prizeDrawUrl
    ) {
      success
    }
  }
`;

export const ADD_DATASHEET_QUESTION_RESULT_COMMENT = gql`
  mutation createDatasheetQuestionResultComment (
    $datasheetQuestionResultId: Int!
    $comment: String!
    $commentVisibleForExternalUser: Boolean!
  ) {
    createDatasheetQuestionResultComment(
      datasheetQuestionResultId: $datasheetQuestionResultId
      comment: $comment
      commentVisibleForExternalUser: $commentVisibleForExternalUser
    ) {
      datasheetQuestionResultComment {
        id
        datasheetQuestionResultId
        comment
        createdAt
        updatedAt
        userName
        createdBy
      }
    }
  }
`;

export const UPDATE_DATASHEET_QUESTION_RESULT_COMMENT = gql`
  mutation updateDatasheetQuestionResultComment (
    $id: Int!
    $comment: String!
  ) {
    updateDatasheetQuestionResultComment (
      id: $id
      comment: $comment
    ) {
      datasheetQuestionResultComment {
        id
        datasheetQuestionResultId
        comment
        createdAt
        updatedAt
        userName
        createdBy
      }
    }
  } 
`;

export const DELETE_DATASHEET_QUESTION_RESULT_COMMENT = gql`
  mutation deleteDatasheetQuestionResultComment (
    $id: Int!
  ) {
    deleteDatasheetQuestionResultComment (
      id: $id
    ) {
      status
    }
  }
`;

export const UPDATE_DATASHEET_QUESTION_RESULT_COMMENT_STATUS = gql`
  mutation updateDatasheetQuestionResult(
    $id: Int!
    $commentStatus: DatasheetQuestionResultsCommentStatusEnum!
  ) {
    updateDatasheetQuestionResult (
      id: $id
      commentStatus: $commentStatus
    ) {
      datasheetQuestionResult {
        id
      }
    }
  }
`;
